import React from "react";

const BasicInfoIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <rect
      x="1"
      y="3"
      width="16"
      height="13"
      rx="2"
      stroke={stroke} // Dynamic stroke color
    />
    <path
      d="M1 5.5H17"
      stroke={stroke} // Dynamic stroke color
    />
    <rect
      x="4"
      y="12"
      width="2"
      height="2"
      rx="1"
      fill={fill} // Dynamic fill color
    />
    <rect
      x="8"
      y="12"
      width="2"
      height="2"
      rx="1"
      fill={fill} // Dynamic fill color
    />
    <rect
      x="12"
      y="12"
      width="2"
      height="2"
      rx="1"
      fill={fill} // Dynamic fill color
    />
  </svg>
);

export default BasicInfoIcon;
